// extracted by mini-css-extract-plugin
export default {"text":"PrivacyPolicy_text__QQPj9","title":"PrivacyPolicy_title__T1cpc"};